import type { FieldConfig } from "@/components/layouts/DetailFields";

/**
 * Resolve the partner to pre-fill when quick-creating a partner contact from a
 * record's partner-contact picker. That field's config carries the record's
 * currently-selected partner in `dependentValues.partner` (populated in
 * entityFieldsUtils/detailFields.tsx); surface it (or null when the record has
 * no partner) so the quick-create modal can pre-fill it.
 *
 * The import is type-only so this stays a light, dependency-free module.
 */
export const resolveCreatePartnerContactPartnerId = (
  config: FieldConfig | undefined
): string | null => {
  if (!config || !("dependentValues" in config)) {
    return null;
  }
  const partner = config.dependentValues?.partner;
  return typeof partner === "string" ? partner : null;
};
